// The hosted player (player.pixelplay.live) in a TV or desktop browser: media is kept in Cache
// Storage and served offline by the service worker (public/sw.js).
import {
  cacheContents,
  pruneContents,
} from '@/modules/player/lib/contentCache';
import { RESET_KEY_CODE } from '../shared/keys';

let wakeLock = null;

const requestWakeLock = async () => {
  if (!navigator.wakeLock || wakeLock) return;
  try {
    wakeLock = await navigator.wakeLock.request('screen');
    wakeLock.addEventListener('release', () => (wakeLock = null));
  } catch {
    // Refused (e.g. the tab is hidden); retried when it becomes visible again.
  }
};

const requestFullscreen = () => {
  const root = document.documentElement;
  if (document.fullscreenElement || !root.requestFullscreen) return;
  root.requestFullscreen().catch(() => {});
};

// Browsers only allow fullscreen from a user gesture, so the first key or click enters it.
const keepAwake = () => {
  requestWakeLock();
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') requestWakeLock();
  });
  window.addEventListener('keydown', requestFullscreen, { once: true });
  window.addEventListener('pointerdown', requestFullscreen, { once: true });
};

const stats = async () => {
  try {
    const { quota, usage } = await navigator.storage.estimate();
    return { freeBytes: quota - usage, usedBytes: usage };
  } catch {
    return { freeBytes: null, usedBytes: null };
  }
};

export const platform = {
  name: 'web',
  isPackaged: false,
  resetKeyCodes: [RESET_KEY_CODE],
  init: keepAwake,
  keepAwake,
  registerKeys() {},
  info: async () => ({ playerType: 'web' }),
  restart: () => {
    window.location.href = '/';
  },
  media: {
    sync: cacheContents,
    prune: pruneContents,
    resolve: (url) => url,
    stats,
  },
};
